import { Ultra24WhySection } from "./Ultra24WhySection";

export const Ultra24GoalsWhyBlock = () => {
  return (
    <div className="bg-white">
      <Ultra24WhySection />
    </div>
  );
};
